import * as React from 'react';

import { imgPath } from '~src/common/utilities/ImgUrl';

import { Messages } from '../../codegen/Localize';
import { TelemetryEvents } from '../../common/telemetryEvents/TelemetryEvents';
import { Telemetry } from '../../commonInfra/services/Telemetry';
import { ChannelStyles } from '../styles/ChannelStyles';
import { HomeStyles } from '../styles/HomeStyles';
import { HomeSeeAllClickEvent } from '../telemetry/HomeTelemetryEvents';
import { ChannelTypes } from '../types/ChannelTypes';

interface ChannelHeaderProps {
  readonly channelType: ChannelTypes;
  readonly title: string;
  readonly seeAllUrl?: string;
  readonly seeAllAltText?: string;
  readonly headerIconPath?: string;
}

export class ChannelHeader extends React.PureComponent<ChannelHeaderProps> {


  constructor(props: ChannelHeaderProps) {
    super(props);
  }

  private sendTelemetryEvent() {
    Telemetry.sendEvent<HomeSeeAllClickEvent>({
      type: TelemetryEvents.HomeSeeAllClick,
      channelType: this.props.channelType
    });
  }

  private mouseUpHandler(event: React.MouseEvent<HTMLAnchorElement>) {
    if(event.button !== 2) {
      this.sendTelemetryEvent();
    }
  }

  private keyPressHandler(event: React.KeyboardEvent<HTMLAnchorElement>) {
    if(event.nativeEvent.key === 'Enter') {
      this.sendTelemetryEvent();
    }
  }

  render() {
    const headerIcon: JSX.Element = this.props.headerIconPath ?
      <img src={imgPath(this.props.headerIconPath)} className={ChannelStyles.headerIcon} alt=''/> : null;
    return (
      <header className={ChannelStyles.header}>
        <h2>{headerIcon}{this.props.title}</h2>
        {this.props.seeAllUrl &&
          <a
            href={this.props.seeAllUrl}
            className={HomeStyles.link}
            data-tb-test-id="channel-see-all-link"
            aria-label={this.props.seeAllAltText}
            onMouseUp={(e) => this.mouseUpHandler(e)}
            onKeyPress={(e) => this.keyPressHandler(e)}
          >
            {Messages.home_seeAll()}
          </a>
          }
      </header>
    );
  }
}
